import { AppConfig } from '@core/domain/AppConfig.ts';
import type { ShellUiMetadataPort } from '../../../app-context/domain/ports/ShellUiMetadataPort.ts';

/** Composition-root adapter; delegates to core `AppConfig`. */
export class ShellUiMetadataFromAppConfig implements ShellUiMetadataPort {
  /** Returns app display title. */

  getAppDisplayTitle(): string {
    return AppConfig.getAppDisplayTitle();
  }
}
